import { axios } from '@/utils/request'

/**
 * 查询列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function assessPage (parameter) {
  return axios({
    url: '/buNurseAssessment/getBuNurseAssessments',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询预约记录详情
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function assessDetial (parameter) {
  return axios({
    url: '/buNurseAssessment/getBuNurseAssessment',
    method: 'get',
    params: parameter
  })
}

/**
 * 更新预约记录
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function assessUpdate (parameter) {
  return axios({
    url: '/buNurseAssessment/updateBuNurseAssessment',
    method: 'post',
    params: parameter
  })
}


/**
 * 获取科室
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingDept (parameter) {
  return axios({
    url: '/dept/getDeptList',
    method: 'get',
    params: parameter
  })
}

// 
/**
 * 根据科室获取医生
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nursingDoct (parameter) {
  return axios({
    url: '/userBasic/list',
    method: 'get',
    params: parameter
  })
}